import React from 'react'
import { Link as LinkPage} from 'react-router-dom'
import "./sectionBlog.css";


function SectionBlog() {
 
  return (
    <section id='blog' className='section_blog'>
      <h1 className='section_blogTitle'>Blog</h1>
      <div className='container blog_main'>
        {/* className='col-lg-6 col-md-12 col-sm-12' */}

         <div className='sectionBlog_content_wrapper'>

           <div className='sectionBlog_content'>
                 <h2 className='blog_title'>
          CryptoCPU: Making Zero-Knowledge Proofs Fast, Cost-Disruptive, and Scalable
        </h2>
          
          <div className='blog_content_underline'>
          
             Zero-knowledge (ZK) proofs are expanding across use cases such as scalability, interoperability, verifiable off-chain computation, privacy, and cross-chain security, making ZK a natural architectural fit for next-generation blockchains. At the same time, Ethereum’s anticipated evolution toward RISC-V at the execution layer and ZK-based transformation of consensus will demand highly efficient compute structures to reduce operational expenses, cut proving latency, and unlock massive scaling while improving privacy, security, and decentralization. CryptoCPU addresses exactly these emerging needs.
          </div>
       
        <div className='blog_content_btn'>
            
              <LinkPage to={'/blog/cryptocpu-making-zero-knowledge-proofs-fast-cost-disruptive-and-scalable'} rel="noopener noreferrer" className='sectionBlog-btn no-wrap'>
                               <span>Learn more</span>
                         </LinkPage>
        </div>
          </div>


           <div className='sectionBlog_content'>
                 <h2 className='blog_title'>
          Tech Deep Dive: CryptoCPU – Powering FHE & ZKPs for Confidential Computing
        </h2>
          
          <div className='blog_content_underline'>
          
             Verifiable and confidential computation is no longer a futuristic concept — it's here, and it's advancing rapidly. These technologies are beginning to solve some of the key barriers preventing large enterprises and FinTech companies from embracing public blockchain infrastructure at scale. They might also enable many use cases in traditional industries such as privacy-preserving cloud computing and machine learning. At the core of this transformation are two powerful technologies: Fully Homomorphic Encryption (FHE) and Zero-Knowledge Proofs (ZKPs).
          </div>
       
        <div className='blog_content_btn'>
            
              <LinkPage to={'/blog/tech-deep-dive'} rel="noopener noreferrer" className='sectionBlog-btn no-wrap'>
                               <span>Learn more</span>
                         </LinkPage>
        </div>
          </div>

            <div className='sectionBlog_content'>
                 <h2 className='blog_title'>
          Scaling Stablecoins with Confidentiality: How CryptoCPU Unlocks Enterprise Adoption through ZKP+FHE
        </h2>
          
          <div className='blog_content_underline'>
          
             Rapid growth of tokenization, prediction markets, and DeFi creates enterprise use cases that need blockchain solutions which are confidential, fast, and secure. Stablecoins enable programmable global money, but adoption is slowed by trust, compliance, and security concerns. Solving this unlocks new business models through a confidential transactions layer. Advanced cryptography—Zero-Knowledge Proofs (ZKPs) and Fully Homomorphic Encryption (FHE)—holds the key. We design CryptoCPU to remove computational obstacles, making them cheap, fast, and ready for scale.
          </div>
       
        <div className='blog_content_btn'>
            
              <LinkPage to={'/blog/scaling-stablecoins-with-confidentiality'} rel="noopener noreferrer" className='sectionBlog-btn no-wrap'>
                               <span>Learn more</span>
                         </LinkPage>
        </div>
          </div>

           <div className='sectionBlog_content'>
              <h2 className='blog_title'>CryptoCPU: validation & proving made fast, affordable and seamless</h2>

         <div className='blog_content_underline'>CryptoCPU is a high-performance computing platform purpose-built to supercharge validation and zero-knowledge (ZK) proving, accelerating critical cryptographic operations through custom RISC-V vector extensions and specialized co-processors. Its efficient architecture delivers exceptional throughput, low latency, and power efficiency, while enabling flexible deployment across diverse systems. With seamless integration, programmability, and scalability, CryptoCPU is powering the next generation of blockchain infrastructure.</div>

         <div className=' blog_content_btn'>
            
              <LinkPage to={'/blog/cryptocpu-validation-proving-made-fast-affordable-and-seamless'} rel="noopener noreferrer" className='sectionBlog-btn no-wrap'>
                               <span>Learn more</span>
                         </LinkPage>
        </div>
           </div>
          
           <div className='sectionBlog_content'>
              <h2 className='blog_title'>Ponos Technology’s <span className='nowrap'>HW-Accelerated</span> Plonky2 GoldiBear: Unleashing Plonky2 Over BabyBear Throughput</h2>

        <div className='blog_content_underline'>Telos R&D team has successfully adapted Polygon Plonky2 to the BabyBear field, unlocking faster and more efficient ZK-based proof aggregation. On top of that, Ponos Technology has introduced HW-accelerated Plonky2 GoldiBear, a groundbreaking solution that merges hardware acceleration with optimized software to deliver unprecedented performance in NTT and Poseidon2-based Merkle tree computations. Across all sizes tested, HW-accelerated Plonky2 implementation surpasses CPU performance by 15 to 40×, underscoring its effectiveness and scalability.</div>

         <div className=' blog_content_btn'>
            
              <LinkPage to={'/blog/ponos-technology-s-hw-accelerated-plonky2-goldibear'} rel="noopener noreferrer" className='sectionBlog-btn no-wrap'>
                               <span>Learn more</span>
                         </LinkPage>
        </div>
           </div>

            <div className='sectionBlog_content'>
                 <h2 className='blog_title'>
          Commoditizing <span className='nowrap'>Zero-Knowledge</span> Proofs: <span className='nowrap'>FPGA-Driven</span> <span className='nowrap'>SW-HW</span> <span className='nowrap'>Co-Design</span> as a Path to ASIC Acceleration
        </h2>
          
          <div className='blog_content_underline'>
          
             Zero Knowledge (ZK) proving is inherently slow and expensive. To solve it, we adopted comprehensive, modular, and fully optimized hardware-software design strategies, pairing with appropriately matched computational infrastructures to meet the specific requirements. To deliver unmatched results, reported in the document, in terms of cost and latency we leverage on FPGAs that play a crucial role in prototyping, serving as an essential bridge toward ASIC development—ultimately the most efficient solution for ZKP acceleration.
          </div>
       
        <div className='blog_content_btn'>
            
              <LinkPage to={'/blog/commoditizing-zero-knowledge-proofs'} rel="noopener noreferrer" className='sectionBlog-btn no-wrap'>
                               <span>Learn more</span>
                         </LinkPage>
        </div>
          </div>

        
         </div>
          
       
      </div>
    </section>
  )
}

export default SectionBlog
